import { localStorageService } from '@/lib/local-storage';
// import { cookieService } from '@/lib/cookie';

const parseJson = (value: string | undefined) => {
  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch (e: unknown) {
      console.error('Failed to parse JSON from localStorage:', e);
      console.error('Value that failed to parse:', value);

      // Check if it's the common [object Object] issue
      if (value === '[object Object]') {
        console.error(
          'This usually happens when an object was stored without proper JSON.stringify()',
        );
      }

      throw new Error(`Invalid JSON: ${value}`);
    }
  }

  return value;
};

const setPersistItem = ({
  value,
  name,
  // options = {},
  stringify = false,
}: {
  value: string | object;
  name: string;
  stringify?: boolean;
  options?: Cookies.CookieAttributes;
}) => {
  const localStorageValue = localStorageService.getLocalStorage(name);
  if (localStorageValue) {
    localStorageService.removeLocalStorage(name);
  }

  // Always stringify objects, but respect the stringify parameter for explicit control
  let valueToStore: string;
  if (typeof value === 'object' && value !== null) {
    // If it's an object, always stringify it
    valueToStore = JSON.stringify(value);
  } else if (stringify || typeof value === 'string') {
    // If stringify is explicitly true, or if it's already a string, use as-is
    valueToStore = value as string;
  } else {
    // For other types (like numbers), convert to string
    valueToStore = String(value);
  }

  localStorageService.setLocalStorage({
    name,
    value: valueToStore,
  });
};

const getPersistItem = <T = unknown>({
  name,
  parse = false,
}: {
  name: string;
  parse?: boolean;
}) => {
  const localStorageValue = localStorageService.getLocalStorage(name);

  if (parse) {
    if (localStorageValue) {
      return parseJson(localStorageValue) as T | undefined;
    }
    return undefined;
  }

  return (localStorageValue || undefined) as T | undefined;
};

const removePersistItem = ({ name }: { name: string }) => {
  localStorageService.removeLocalStorage(name);
};

const batchRemovePersistItems = ({ names }: { names: string[] }) => {
  names.forEach((name) => {
    localStorageService.removeLocalStorage(name);
  });
};

const clearPersistStorage = () => {
  localStorageService.clearLocalStorage();
};

export const persistStorageService = {
  setPersistItem,
  getPersistItem,
  removePersistItem,
  batchRemovePersistItems,
  clearPersistStorage,
};
